import type { NameSearchResult as RawNameSearchResult } from '@rover/rsdk/src/apiClient/latest/model/nameSearchResult';

import type { NameSearchResult } from '../types';

export function mapToCardResult(raw: RawNameSearchResult): NameSearchResult {
  // personOpk is non-optional on the backend, but typed as nullable.
  // Fall back to personPk as a string so testID / key stay stable when null.
  const personOpk = raw.personOpk ?? (raw.personPk != null ? String(raw.personPk) : '');

  return {
    personOpk,
    personName: raw.personFullName ?? '',
    shortName: raw.personShortName ?? '',
    avatarUrl: raw.defaultImage ?? null,
    profileUrl: raw.profileUrl ?? '',
    isPreviouslyBooked: raw.previouslyBooked ?? false,
    ratingsAverage: raw.ratingsAverage ?? undefined,
    reviewsCount: raw.reviewsCount ?? undefined,
    isStarSitter: raw.isStarSitter ?? undefined,
  };
}
